<template>
  <div v-if="content !== null" class="control">
    <base-file-field
      v-model="files"
      :title="title"
      :no-files-label="content.UploadFileFormViewModel.FileListNoFilesLabel"
      :remove-file-label="content.UploadFileFormViewModel.FileListButtonRemoveLabel"
      button-class="text-center"
      :data-vv-as="content.UploadFileFormViewModel.FileChooseFieldName"
      :add-file-label="content.UploadFileFormViewModel.FileChooseButtonLabel"
      :error-modal-title="content.UploadFileFormViewModel.FileErrorModalHeadline"
      :error-modal-filetypes-link-url="
        content.UploadFileFormViewModel.FileErrorModalSupportedTypesLink.Url
      "
      :error-modal-filetypes-link-text="
        content.UploadFileFormViewModel.FileErrorModalSupportedTypesLink.Text
      "
      :error-modal-button-label="content.UploadFileFormViewModel.FileErrorModalCloseButtonLabel"
      :required="false"
      @update:model-value="$emit('update:modelValue', files)"
    />

    <p class="push-up" data-test-upload-file-info-text v-html="content.UploadFileInfoBoxText" />
  </div>
</template>

<script>
import BaseFileField from '@/components/Forms/BaseFileField/BaseFileField.vue';

export default {
  name: 'Upload',
  emits: ['update:modelValue'],
  components: { BaseFileField },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    content: {
      type: Object,
      default() {
        return null;
      }
    },
    title: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      files: []
    };
  },
  mounted() {
    this.files = this.modelValue;
  }
};
</script>
